






























































































































































































































































































































































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";

@Component({})
export default class BulkSchemaMapping extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private accountId!: string;
  @Prop() private companyId!: string;
  @Prop() private jobId!: string;

  private schemaData: any = null;
  private inputFields = [];
  private loading = false;

  private requiredFields = ["title", "itemCode"];
  private finalMappingsToSave = {};
  private errorMessageTop = "";
  private hideIdentifiers = true;

  async mounted() {
    this.$store.commit("startLoading");
    this.loading = true;
    try {
      const response = await this.$api.get(
        `item-classification-api/v1/company/${this.companyId}/defaultSchema`
      );
      this.schemaData = response.data;
      this.$store.commit("stopLoading");
      this.loading = false;
    } catch (error) {
      this.displayError(error);
      this.$store.commit("stopLoading");
      this.loading = false;
    }

    this.inputFields = this.schemaData.schema.fields.map((f) => f.name);
    this.finalMappingsToSave = {};
  }

  toggleIdentifiersView() {
    this.hideIdentifiers = !this.hideIdentifiers;
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  areMultipleColumnsSelected(bulkField) {
    return (
      this.finalMappingsToSave[bulkField] &&
      this.finalMappingsToSave[bulkField].fields.length > 1
    );
  }

  joinMethodOptions(bulkField) {
    return ["concat", "coalesce"].map((option) => {
      return {
        label: option,
        value: option,
        selected:
          this.finalMappingsToSave[bulkField] &&
          this.finalMappingsToSave[bulkField].joinType == option,
      };
    });
  }

  joinMethodSelected(e, bulkField) {
    const currentSelections = this.finalMappingsToSave[bulkField]
      ? this.finalMappingsToSave[bulkField].fields
      : [];
    this.$set(this.finalMappingsToSave, bulkField, {
      delimiter: "-",
      fields: currentSelections,
      joinType: e.detail.item.value,
    });
  }

  onSeparatorChange(e, bulkField) {
    const currentSelections = this.finalMappingsToSave[bulkField]
      ? this.finalMappingsToSave[bulkField].fields
      : [];
    this.$set(this.finalMappingsToSave, bulkField, {
      delimiter: e.target.value,
      fields: currentSelections,
      joinType: "concat",
    });
  }

  async saveAndNext() {
    this.$store.commit("startLoading");
    this.loading = true;
    const isSuccess = await this.saveMappings();
    if (isSuccess) {
      (this.$parent as any).gotoStep(0);
    }
  }

  async saveMappings() {
    const finalMappings = this.nonEmptyMappings(this.finalMappingsToSave);
    try {
      const saveMappingsResponse = await this.$api.put(
        `item-classification-api/v1/company/${this.companyId}/defaultMapping`,
        finalMappings
      );
      return true;
    } catch (error) {
      this.displayError(error);
      this.loading = false;
      this.$store.commit("stopLoading");
      return false;
    }
  }

  private singleMappingSelected(e, bulkField) {
    const selectedInputField = e.detail.item.value;
    this.$set(this.finalMappingsToSave, bulkField, {
      delimiter: "-",
      fields: [selectedInputField],
      joinType: "concat",
    });
  }

  private multiMappingSelected(e, bulkField) {
    const selectedInputField = e.detail.item.value;
    const currentSelections = this.finalMappingsToSave[bulkField]
      ? this.finalMappingsToSave[bulkField].fields
      : [];
    this.$set(this.finalMappingsToSave, bulkField, {
      delimiter: "-",
      fields: currentSelections.concat([selectedInputField]),
      joinType: "concat",
    });
  }

  private multiMappingDeselected(e, bulkField) {
    const selectedInputField = e.detail.item.value;
    const currentSelections = this.finalMappingsToSave[bulkField]
      ? this.finalMappingsToSave[bulkField].fields
      : [];
    this.$set(this.finalMappingsToSave, bulkField, {
      delimiter: "-",
      fields: currentSelections.filter(
        (option) => option != selectedInputField
      ),
      joinType: "concat",
    });
  }

  inputFieldOptionsForSingleselect(bulkField) {
    if (!this.inputFields || this.inputFields.length == 0) return [];
    const currentSelection: string =
      this.finalMappingsToSave[bulkField] &&
      this.finalMappingsToSave[bulkField].fields.length > 0
        ? this.finalMappingsToSave[bulkField].fields[0]
        : "";
    return [{ label: "", value: "", selected: currentSelection === "" }].concat(
      this.inputFields.map((x) => {
        return {
          label: x,
          value: x,
          selected: currentSelection === x,
        };
      })
    );
  }

  inputFieldOptionsForMultiselect(bulkField) {
    if (!this.inputFields || this.inputFields.length == 0) return [];
    const currentSelections: string[] = this.finalMappingsToSave[bulkField]
      ? this.finalMappingsToSave[bulkField].fields
      : [];
    return this.inputFields.map((x: string) => {
      return {
        label: x,
        value: x,
        selected: currentSelections.indexOf(x) >= 0,
      };
    });
  }

  private nonEmptyMappings(mappings: object): object {
    return this.$_.pickBy(
      mappings,
      (x) => !this.$_.isEmpty(x.fields) && x.fields[0] != ""
    );
  }

  private isSavePossible() {
    const finalMappings = this.nonEmptyMappings(this.finalMappingsToSave);
    const finalMappingsCount = Object.keys(finalMappings).length;
    const areRequiredFieldsPopulated = this.requiredFields.every(
      (requiredField) =>
        finalMappings[requiredField] &&
        finalMappings[requiredField].fields.length > 0
    );
    return areRequiredFieldsPopulated && finalMappingsCount > 0;
  }

  private previous() {
    (this.$parent as any).previousStep();
  }

  private cancel() {
    (this.$parent as any).gotoStep(0);
  }
}
